import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";

import reportWebVitals from "./reportWebVitals";
import store, { persistor } from "./store";
import { ClientRoute } from "route/ClientRoute";
import { FT_TOKEN_KEY } from "constants/session";

import "@firstech-cloud-saas/firstech-ui";

import "index.scss";
import "./assets/stylesheets/style.css";

/*
 * Removing token on application load.
 * And it'll stay there till application reload.
 */
sessionStorage.removeItem(FT_TOKEN_KEY);

const container = document.getElementById("root");
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ClientRoute />
      </PersistGate>
    </Provider>
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
